module.exports = __webpack_public_path__ + "static/media/Cecelia.6d1cc00f.jpg";